import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Divider } from "@mui/material";
import Stack from "@mui/material/Stack";
import { ExtraSmallFab } from "../../Buttons/ExtraSmallFAB";
import { BrandLogoLink } from "../BrandLogoLink";
export const NavDrawerHeader = ({ setIsOpen }) => {
    return (_jsxs(Stack, Object.assign({ my: 3, spacing: 2 }, { children: [_jsxs(Stack, Object.assign({ spacing: 2, px: 2, direction: "row", alignItems: "center", justifyContent: "space-between" }, { children: [_jsx(BrandLogoLink, { logoStyles: {
                            maxWidth: "100%",
                            maxHeight: "50px",
                        } }), _jsx(Box, Object.assign({ ml: 1 }, { children: _jsx(ExtraSmallFab, { icon: CloseIcon, "aria-label": "close", onClick: () => setIsOpen(false) }) }))] })), _jsx(Divider, { flexItem: true })] })));
};
